module.exports = __webpack_public_path__ + "img/97.06ee4c0d.jpg";